import { useEffect, useState } from "react";
import { supabase } from "@/shared/integrations/supabase/client";
import type { CategoryWithSchema } from "./types";

export function useAssetCategories() {
  const [categories, setCategories] = useState<CategoryWithSchema[]>([]);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const { data, error } = await supabase
          .from('asset_categories')
          .select(`
            id,
            name,
            asset_category_attribute_schemas (
              schema
            )
          `)
          .order('name');

        if (error) throw error;
        if (data) {
          setCategories(data.map((c: any) => ({
            id: c.id,
            name: c.name,
            schema: c.asset_category_attribute_schemas?.[0]?.schema || null
          })));
        }
      } catch (err) {
        console.error('Failed to load asset categories:', err);
      }
    };
    loadCategories();
  }, []);

  return categories;
}
